import React, { useState } from 'react';
import { createRoot } from 'react-dom/client'
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import {getDeviceLabels} from '../../../utils/helpers'
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';



const SEARCH_URI = '/api/data/devices/all';

const AutocompleteAll = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedByUser, setSelectedByUser] = useState(null);

    

    // useEffect(() => {
    //     setTags(JSON.parse(props.default));
    //     if(props.type == 'smartphones' || props.type == 'smartwatches'){
    //         axios.get('/api/data/devices/'+props.type)
    //         .then( res => {
    //             //console.log(res)
    //             setDevices(res.data);
    //         })
    //         .catch(err => {
    //             console.log(err)
    //         });
    //     }
    // }, []);


    const handleSearch = (query) => {
        setIsLoading(true);

        axios.get(`${SEARCH_URI}?q=${query}`)
            .then(res => {
                setOptions(res.data);
                setIsLoading(false);
            })
            .catch(err => {
                console.log(err)
            });
    };

    const handleOnchange = (selected) => {
        const deviceLabels = getDeviceLabels(selected[0].type);
        window.location.href = `/${deviceLabels.folder}/${selected[0].slug}`;
    }

    // const imageOnLoadHandler = (event) => {
    //     console.log(
    //       `The image with url of ${event.currentTarget.src} has been loaded`
    //     );

    // }

    const imageOnErrorHandler = (event, folder) => {
        event.currentTarget.src = `/storage/${folder}/default-x-small.webp`;
    };

    const filterBy = () => true;


    return (
        <div className="custom-dropdown position-relative">
            {/* <SearchIcon
                className="icon-search"
                style={{ color: "#CB3066" }}
            /> */}
            {isLoading ? (
                <div className="position-absolute start-0 top-0 z-2">
                    <div className="spinner-grow text-light" role="status"  style={{margin:'5px 0 0 3px', width: '1.5rem', height: '1.5rem'}}>
                        <span className="sr-only"></span>
                    </div>
                    {/* <CircularProgress style={{ width: '15px', height: '15px', zIndex: 99999, position: 'absolute', top: '35px', left: '5px' }} className="spinnerAutocomp" /> */}
                </div>
            ) : null}
            <AsyncTypeahead
                inputProps={{
                    className: 'ms-5',
                    style: {width: '100%'}
                }}
                filterBy={filterBy}
                id="async-example"
                isLoading={isLoading}
                labelKey="name"
                minLength={3}
                emptyLabel={'Ningún resultado encontrado.'}
                onSearch={handleSearch}
                options={options}
                onChange={(selected) => handleOnchange(selected)}
                placeholder="Buscar un dispositivo......"
                renderMenuItemChildren={(option, props) => (
                    <ul className="list-group" >
                        <li className="list-group-item list-group-item-action">
                            {option.type == 'Smartwatch' ? (
                                // <i className="fas fa-clock mr-2"></i>
                                <img className="me-3" height="40" src={`/storage/smartwatches/${option.id}/${option.slug}_0-x-small.webp`} alt={option.name} onError={(e) => imageOnErrorHandler(e, 'smartwatches')} />
                            ) : (option.type == 'Mediaplayer') ? (
                                // <i className="fas fa-tv mr-2"></i>
                                <img className="me-3" height="40" src={`/storage/devices/${option.id}/${option.slug}-x-small.jpg`} alt={option.name} onError={(e) => imageOnErrorHandler(e, 'mediaplayers')} />
                            ) : (option.type == 'Headphone') ? (
                                // <i className="fas fa-headphones-alt mr-2"></i>
                                <img className="me-3" height="40" src={`/storage/devices/${option.id}/${option.slug}-x-small.jpg`} alt={option.name} onError={(e) => imageOnErrorHandler(e, 'headphones')} />
                            ) : (
                                // <i className="fas fa-mobile-alt mr-2"></i>
                                <img className="me-3" height="40" src={`/storage/devices/${option.id}/${option.slug}-x-small.jpg`} alt={option.name} onError={(e) => imageOnErrorHandler(e, 'devices')} />
                            )}
                            <span>{option.name}</span>
                        </li>
                    </ul>
                )}
            >


            </AsyncTypeahead>
        </div>

    );
}

export default AutocompleteAll;

// if (document.getElementsByClassName('autocompleteAll')) {
//     const list = document.getElementsByClassName("autocompleteAll");
//     for (const item of list) {
//         createRoot(item).render(<AutocompleteAll {...item.dataset} />)
//     }

// }

